import styled from "styled-components";
import React from "react";
import Progress from "./Progress";

const ProgressContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 100;
  top: 0;
  right: 0;
`;

const ProgressOverlay = styled.div`
  opacity: 0.5;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
`;

const TabProgress = ({ size = "xl2" }) => <ProgressContainer>
	<ProgressOverlay className="bg-source-bg"/>
	<Progress overlay size={size}/>
</ProgressContainer>;

export default TabProgress;
